import { render, staticRenderFns } from "./AddTareaPage.vue?vue&type=template&id=1149a1e8"
import script from "./AddTareaPage.vue?vue&type=script&lang=js"
export * from "./AddTareaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports